import React from 'react';
import { Button, Icon, Segment } from 'semantic-ui-react';
import PaymentMethodInfo from './PaymentMethodInfo';
import { PAYMENT_WHATSAPP_URL } from './paymentContactInfo';
import { PAYMENT_BLOCKED_COLORS } from './paymentBrand';
import './payments.css';

function formatAmount(amount) {
  if (amount === null || amount === undefined) return null;
  return `$${Number(amount).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;
}

const METHODS_ANCHOR_ID = 'payment-blocked-methods';

/**
 * Blocked-login state. Purely presentational: the app decides when to show
 * it (a 402 PAYMENT_BLOCKED response), this component only explains why and
 * how to resolve it in plain language.
 */
function PaymentBlockedCard({ amount = null, onShareProof }) {
  const formattedAmount = formatAmount(amount);

  const handleShareProof = () => {
    if (onShareProof) {
      onShareProof();
      return;
    }
    window.open(PAYMENT_WHATSAPP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Segment
      className="payment-banner"
      style={{ textAlign: 'left', borderRadius: 14, padding: 24, marginBottom: 20 }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: 16 }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: PAYMENT_BLOCKED_COLORS.iconBackground,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 12,
          }}
        >
          <Icon name="lock" size="large" style={{ color: PAYMENT_BLOCKED_COLORS.iconColor, margin: 0 }} />
        </div>
        <div style={{ fontSize: 18, fontWeight: 700, color: PAYMENT_BLOCKED_COLORS.titleColor, marginBottom: 6 }}>
          Acceso bloqueado por pago pendiente
        </div>
        <div style={{ fontSize: 13.5, color: PAYMENT_BLOCKED_COLORS.textColor, lineHeight: 1.5 }}>
          Tu acceso a MercuryCom está bloqueado por un pago pendiente. Para volver a ingresar, contactate con
          atención al cliente por WhatsApp.
          {formattedAmount ? ` Monto pendiente: ${formattedAmount}.` : ''}
        </div>
      </div>

      <div
        id={METHODS_ANCHOR_ID}
        style={{ background: '#F9FAFB', border: '1px solid #F3F4F6', borderRadius: 12, padding: 14, marginBottom: 16 }}
      >
        <div
          style={{
            fontSize: 12.5,
            fontWeight: 700,
            color: '#6B7280',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
            marginBottom: 10,
          }}
        >
          Contacto
        </div>
        <PaymentMethodInfo />
      </div>

      <Button type="button" color="violet" fluid size="large" onClick={handleShareProof} style={{ marginBottom: 0 }}>
        Contactar a atención al cliente
      </Button>
    </Segment>
  );
}

export default PaymentBlockedCard;
